/**
 * Active ideas per industry: the top industries by count, then Other (the rest, added
 * up) and Unassigned, in the audit families' fixed palette. A legend entry
 * opens the Ideas list filtered to that industry; Other has no filter of its
 * own, so it stays plain.
 */

import type { Dashboard } from '@/api/types';
import { opportunitiesHref } from '@/routes/business-opportunities/ideaFilters';
import { formatPct } from '@/ui/format';
import { SplitCard } from '@/ui/SplitCard';

export function IndustryCard({ data }: { data: Dashboard['industries'] }) {
  const lead = data.slices[0];
  return (
    <SplitCard
      label="Ideas by industry"
      figure={data.industries}
      noun={data.industries === 1 ? 'industry with active ideas' : 'industries with active ideas'}
      aside={
        lead?.id && data.total > 0 ? (
          <span className="usage-card-of">
            {lead.name} {formatPct((lead.count / data.total) * 100)}
          </span>
        ) : undefined
      }
      parts={data.slices.map((s, i) => ({ key: s.key, label: s.name, count: s.count, seg: `seg-family-${i + 1}` }))}
      linkFor={(key) => (key === 'other' ? null : opportunitiesHref({ view: 'list', dispositions: ['active'], industries: [key] }))}
    />
  );
}
